var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_445)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 34C33.1046 34 34 33.1046 34 32C34 30.8954 33.1046 30 32 30C30.8954 30 30 30.8954 30 32C30 33.1046 30.8954 34 32 34ZM36 32C36 34.2091 34.2091 36 32 36C29.7909 36 28 34.2091 28 32C28 29.7909 29.7909 28 32 28C34.2091 28 36 29.7909 36 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 26C36.2425 26 35.5499 25.572 35.2111 24.8944L35.0403 24.5528C34.8709 24.214 34.5247 24 34.1459 24H29.8541C29.4753 24 29.1291 24.214 28.9597 24.5528L28.7889 24.8944C28.4501 25.572 27.7575 26 27 26H25C24.4477 26 24 26.4477 24 27V37C24 37.5523 24.4477 38 25 38H39C39.5523 38 40 37.5523 40 37V27C40 26.4477 39.5523 26 39 26H37ZM37 24L36.8292 23.6584C36.321 22.642 35.2822 22 34.1459 22H29.8541C28.7178 22 27.679 22.642 27.1708 23.6584L27 24H25C23.3431 24 22 25.3431 22 27V37C22 38.6569 23.3431 40 25 40H39C40.6569 40 42 38.6569 42 37V27C42 25.3431 40.6569 24 39 24H37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 28.5C38.5 29.0523 38.0523 29.5 37.5 29.5C36.9477 29.5 36.5 29.0523 36.5 28.5C36.5 27.9477 36.9477 27.5 37.5 27.5C38.0523 27.5 38.5 27.9477 38.5 28.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.25bd63fbf6b1242d7121f10267eef6c6.svg";
export { ForwardRef as ReactComponent };